
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.137.744L.234 4.647a1.09 1.09 0 00.162 1.515l2.942 2.942a1.09 1.09 0 001.515.162l3.903-3.903a.864.864 0 00.24-.688l-.204-2.771A1.34 1.34 0 007.596.708L4.825.504a.864.864 0 00-.688.24zm2.24 3.04a.637.637 0 01-.462-.199.637.637 0 010-.924.653.653 0 11.924.924.637.637 0 01-.462.198z","fill":"#fff"}})])
          )
        }
      }
    